export const WEAVE_FONT = 'ArtifaktElement, "Artifakt Element", Roboto, sans-serif';
